module.exports = __webpack_public_path__ + "img/1.a17d6b89.png";